<div
  class="z-multi-input p-component p-element p-inputwrapper"
  [class.p-inputwrapper-filled]="filled"
  [class.p-inputwrapper-focus]="hasFocus"
  [class.z-multi-input-clearable]="clearButton"
  [class.with-label]="!!label"
  [class.with-hint]="!!hint"
  [class.has-value]="hasValue$ | async"
  [class.is-readonly]="readonly"
  [class.is-disabled]="disabled"
  [ngStyle]="style"
  [ngClass]="styleClass"
  (click)="onClick()"
>
  <label *ngIf="!!label" [for]="inputId">
    {{ label }}
  </label>

  <div class="z-multi-input-token-wrapper">
    <ul [ngClass]="{ 'p-inputtext z-multi-input-multiple-container': true, 'p-focus': hasFocus, 'p-disabled': disabled }">
      <li #token *ngFor="let item of value; let i = index" class="z-multi-input-token" (click)="onItemClick($event, item)">
        <span class="z-multi-input-token-label">{{ item }}</span>
        <span *ngIf="!disabled" class="z-multi-input-token-icon pi pi-times-circle" (click)="removeItem($event, i)"></span>
      </li>

      <li class="z-multi-input-input-token" [ngClass]="{ 'z-multi-input-clearable': clearButton && !disabled }">
        <input
          #inputtext
          type="text"
          [attr.id]="inputId"
          [attr.placeholder]="value && value.length ? null : placeholder"
          [attr.tabindex]="tabindex"
          (keydown)="onKeydown($event)"
          (input)="onInput()"
          (paste)="onPaste($event)"
          (focus)="onInputFocus($event)"
          (blur)="onInputBlur($event)"
          [disabled]="disabled"
          [ngStyle]="inputStyle"
          [class]="inputStyleClass"
        />
      </li>
    </ul>

    <div class="z-multi-input-clear-wrapper" *ngIf="value !== null && filled && !disabled && clearButton">
      <i class="z-multi-input-clear-icon pi pi-times" (click)="onClear()"></i>
    </div>
  </div>
</div>
